import * as SVGImages from "../components/proto/svg";

export const TipoDeSolicitud = {
  None: { id: 0, image: SVGImages.Unknown },
  LimiteCredito: { id: 1, image: SVGImages.MoneyCash },
  Nivel: { id: 2, image: SVGImages.Change },
  Congelar: { id: 3, image: SVGImages.WinterFreeze },
  Descongelar: { id: 4, image: SVGImages.SunFilled },
  ResetPassword: { id: 5, image: SVGImages.PasswordError },
  OrdenVentaCreada: { id: 7, image: SVGImages.Order },
  OrdenVentaCancelada: { id: 8, image: SVGImages.OrderCloseFilled },
  OrdenVentaEditada: { id: 9, image: SVGImages.OrderDoneOutline },
};
